const esLang = {
  'codigo-de-etica': 'Código de Ética',
  'claves-de-autorizacion': 'Claves de Autorización',
  'aviso-de-privacidad': 'Aviso de Privacidad'
}
const enLang = {
  'codigo-de-etica': 'Code of Ethics',
  'claves-de-autorizacion': 'Authorization Keys',
  'aviso-de-privacidad': 'Notice of Privacy'
}

export const langTexts = {
  es: esLang,
  en: enLang
}